import { db } from "./firebase";
import {
  collection,
  getDocs,
  addDoc,
  updateDoc,
  deleteDoc,
  doc,
  query,
  orderBy,
  serverTimestamp,
} from "firebase/firestore";

const JOBS_COLLECTION = "jobs";

/**
 * Fetch all jobs, sorted newest-first.
 * @returns {Promise<Array>}
 */
export async function getJobs() {
  const q = query(
    collection(db, JOBS_COLLECTION),
    orderBy("created_at", "desc")
  );
  const snapshot = await getDocs(q);
  return snapshot.docs.map((d) => ({ id: d.id, ...d.data() }));
}

/**
 * Create a new job listing.
 * @param {{ role: string, location: string, type: string }} data
 * @returns {Promise<{id: string, role: string, location: string, type: string}>}
 */
export async function saveJob(data) {
  const ref = await addDoc(collection(db, JOBS_COLLECTION), {
    role:        data.role,
    location:    data.location,
    type:        data.type,
    description: data.description || "",
    created_at:  serverTimestamp(),
  });
  return { id: ref.id, ...data };
}

/**
 * Update an existing job listing.
 * @param {string} id
 * @param {{ role: string, location: string, type: string }} data
 * @returns {Promise<{id: string, role: string, location: string, type: string}>}
 */
export async function updateJob(id, data) {
  const ref = doc(db, JOBS_COLLECTION, id);
  await updateDoc(ref, {
    role:        data.role,
    location:    data.location,
    type:        data.type,
    description: data.description || "",
  });
  return { id, ...data };
}

/**
 * Delete a job listing.
 * @param {string} id
 * @returns {Promise<void>}
 */
export async function deleteJob(id) {
  const ref = doc(db, JOBS_COLLECTION, id);
  await deleteDoc(ref);
}
